import React, {Component} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faAngleDown,
  faPhoneAlt,
  faTasks
} from "@fortawesome/free-solid-svg-icons";

export default class ContactBlocks extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {dataKind, optionBlockShow} = this.props
    const isOpened = optionBlockShow.value === "contact" && optionBlockShow.isOpen
    return (
      window.innerWidth > 480 ?
        <li>
          <a href="#!" style={{backgroundColor: isOpened ? "#eee" : "#fff"}}
             onClick={() => this.props.handleOpenBlockOptions("contact")}>
            <FontAwesomeIcon icon={isOpened ? faAngleDown : faAngleRight}/>
            <p>お問い合わせ受付</p>
          </a>
          {isOpened &&
          <ul>
            <li><a href="#!" onClick={this.props.handleSwitchTabs} data-type="blockTel"
                   className={dataKind == 'blockTel' ? 'selected' : ''}>
              <FontAwesomeIcon icon={faPhoneAlt}/>電話番号</a>
            </li>
            <li><a href="#!" onClick={this.props.handleSwitchTabs} data-type="blockForm"
                   className={dataKind == 'blockForm' ? 'selected' : ''}>
              <FontAwesomeIcon icon={faTasks}/>お問い合わせフォーム</a>
            </li>
          </ul>
          }
        </li>
        :
        <>
          <li><a href="#!" onClick={this.props.handleSwitchTabs} data-type="blockTel"
                 className={dataKind == 'blockTel' ? 'selected' : ''}>
            <FontAwesomeIcon icon={faPhoneAlt}/>電話番号</a>
          </li>
          <li><a href="#!" onClick={this.props.handleSwitchTabs} data-type="blockForm"
                 className={dataKind == 'blockForm' ? 'selected' : ''}>
            <FontAwesomeIcon icon={faTasks}/>お問い合わせフォーム</a>
          </li>
        </>
    )
  }
}
